import { render, staticRenderFns } from "./PublicLayoutHeader.vue?vue&type=template&id=2fe16a6c&"
import script from "./PublicLayoutHeader.vue?vue&type=script&lang=js&"
export * from "./PublicLayoutHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports